var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 76 30",
    width: 76,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#741de1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9938fa"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 3.01387,
    x2: 3.01387,
    xlinkHref: "#a",
    y1: 11.1087,
    y2: 21.8182
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 19.091,
    x2: 19.091,
    xlinkHref: "#a",
    y1: 8.24842,
    y2: 16.6298
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 10.9617,
    x2: 10.9617,
    y1: 1.78149,
    y2: 27.614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b67dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#741ee2"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h76v30h-76z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.6191 22.0148v-18.29263h.7944v18.29263z",
    fill: "#7720e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5176 29.3955v-29.3955l.8896.00000003v29.39549997z",
    fill: "#af73fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.38281 28.6002v-23.41465h1.01672v23.41465z",
    fill: "#741ee2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.93961c0-.492.398302-.89078.889631-.89078h4.066889c.49134 0 .88963.39878.88963.89078v15.04769c0 .492-.39829.8908-.88963.8908h-4.066889c-.49133 0-.889631-.3988-.889631-.8908z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0771 6.74453c0-.49195.3983-.89077.8897-.89077h4.0669c.4913 0 .8896.39881.8896.89077v11.38917c0 .492-.3983.8908-.8896.8908h-4.0669c-.4914 0-.8897-.3988-.8897-.8908z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.00684 2.67227c0-.49196.39834-.89078.88963-.89078h4.13043c.4913 0 .8897.39882.8897.89078v24.05093c0 .4919-.3984.8908-.8897.8908h-4.13043c-.49129 0-.88963-.3989-.88963-.8908z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#111214"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.368 25.6097c-1.0139 0-1.9192-.0278-2.7158-.0833-.7786-.0555-1.4576-.1111-2.037-.1666v-19.9697c.7243-.03703 1.6477-.08332 2.7702-.13887 1.1407-.07406 2.2724-.11109 3.3949-.11109 1.1407 0 2.2089.07406 3.2048.22219 1.0139.12961 1.9011.37958 2.6615.7499.7605.37033 1.3579.89803 1.7925 1.58312.4345.66659.6518 1.52759.6518 2.58305 0 .9258-.2806 1.7868-.8419 2.583s-1.3942 1.398-2.4986 1.8053l.0271.0278c.7786.2221 1.4666.574 2.0641 1.0554.5975.4629 1.0592 1.0276 1.3851 1.6942.344.6666.516 1.398.516 2.1942 0 1.1109-.2172 2.0553-.6518 2.8329-.4164.7593-1.0501 1.3702-1.9011 1.8332-.851.4443-1.9283.7776-3.2319.9999-1.3036.2036-2.8336.3054-4.5899.3054zm1.7925-3.9439c.5432 0 1.023-.0463 1.4394-.1388.4165-.1112.7605-.2593 1.0321-.4445.2716-.2036.4798-.4536.6246-.7498.1449-.3148.2173-.6759.2173-1.0832 0-.8703-.2897-1.4906-.8691-1.8609-.5794-.3889-1.3036-.5833-2.1727-.5833h-1.8739v4.8605c.2535.0186.4978.0278.7332.0278.2535-.0185.5432-.0278.8691-.0278zm-.3259-8.4989c.7061 0 1.2946-.0741 1.7653-.2222.4889-.1666.851-.4073 1.0864-.7221.2354-.3333.3531-.75.3531-1.2499 0-.6851-.2354-1.18503-.7062-1.49981-.4526-.33329-1.0501-.4999-1.7925-.4999-.4526 0-.8781.01851-1.2764.05553-.3983.03703-.6337.05554-.7061.05554v4.08284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.6417 11.0004 4.9973-.1111v14.5537h-4.9973zm2.4986-1.24985c-.7604 0-1.4122-.24073-1.9554-.72212-.5432-.4999-.8148-1.14798-.8148-1.94419 0-.7962.2716-1.44427.8148-1.9442.5432-.49994 1.195-.7499 1.9554-.7499.7605 0 1.4123.24996 1.9555.7499.5432.49993.8147 1.148.8147 1.9442 0 .79621-.2715 1.44429-.8147 1.94419-.5432.48139-1.195.72212-1.9555.72212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.0942 15.9444c0-.9444-.0091-1.8239-.0271-2.6386 0-.8332-.0182-1.6017-.0544-2.3053l4.264-.111.3259 1.6109h.1086c.3078-.2407.679-.5 1.1135-.7777.4527-.2962.9597-.5463 1.5209-.7499.5794-.2037 1.2041-.3056 1.874-.3056.9234 0 1.6929.1667 2.3085.5.6336.3333 1.1224.787 1.4666 1.3609.3618.574.6153 1.2406.7608 1.9998.1629.7591.244 1.5646.244 2.4164v8.4989h-4.9972v-8.3879c0-.4073-.0453-.7499-.1358-1.0276-.0724-.2962-.181-.5463-.3259-.7499-.1448-.2037-.3259-.3518-.5432-.4444-.2172-.0926-.4707-.1388-.7604-.1388-.3078 0-.5975.0462-.8691.1388-.2535.0926-.4889.2222-.7061.3889-.1992.1481-.3893.3054-.5703.4721v9.7488h-4.9973z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinlogo);
export default __webpack_public_path__ + "static/media/binlogo.21628c343bf42bbc540f6ef219977713.svg";
export { ForwardRef as ReactComponent };